import { render } from "./SidebarSeparator.vue?vue&type=template&id=ab72cd5c&ts=true"
import script from "./SidebarSeparator.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarSeparator.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarSeparator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab72cd5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab72cd5c', __exports__)) {
    api.reload('ab72cd5c', __exports__)
  }
  
  module.hot.accept("./SidebarSeparator.vue?vue&type=template&id=ab72cd5c&ts=true", () => {
    api.rerender('ab72cd5c', render)
  })

}


export default __exports__